import { cx } from '@linaria/core';
import { useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useNotifier } from '@provider/notifier';
import { PauseIcon, PM2AudioIcon } from '@ui/kit/icons';
import { describeArcPath } from '@utils/common';
import { useAudio, CSSRefTransition } from '@utils/react';
import { icon, crossFadeDurationMs, asyncProgressCircle, audioButton, modifiers } from './audio-button.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function AudioButton(props) {
  const notifier = useNotifier();
  const audio = useAudio({
    src: props.src,
    notifier
  });
  const handleToggleAudio = evt => {
    evt.stopPropagation();
    props.onAudioClicked?.();
    if (audio.isPlaying) {
      audio.pause();
      audio.seek(0);
    } else {
      audio.resume();
    }
  };
  useEffect(() => {
    if (!props.canPlay) {
      audio.pause();
      audio.seek(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.canPlay]);
  const currentProgress = !audio.timeElapsedMs || !audio.durationMs ? 0 : Number(audio.timeElapsedMs) / Number(audio.durationMs);
  return /*#__PURE__*/jsx("button", {
    className: cx(audioButton, audio.isPlaying && modifiers.isPlaying.className),
    onClick: handleToggleAudio,
    onKeyDown: evt => evt.stopPropagation(),
    tabIndex: props.tabIndex,
    children: /*#__PURE__*/jsxs(TransitionGroup, {
      component: null,
      children: [/*#__PURE__*/jsx(CSSRefTransition, {
        timeout: crossFadeDurationMs,
        classNames: icon,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: icon,
          children: audio.isPlaying ? /*#__PURE__*/jsx(PauseIcon, {
            width: 13
          }) : /*#__PURE__*/jsx(PM2AudioIcon, {
            width: 22
          })
        })
      }, `icon-${audio.isPlaying}`), audio.isPlaying && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: crossFadeDurationMs,
        classNames: asyncProgressCircle,
        children: ref => /*#__PURE__*/jsx("svg", {
          ref: ref,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: `0 0 44 44`,
          className: asyncProgressCircle,
          children: /*#__PURE__*/jsx("path", {
            d: describeArcPath(44, 2, Math.min(359.99, Math.round(currentProgress * 360)))
          }, "progress")
        })
      })]
    })
  });
}

export { AudioButton };
//# sourceMappingURL=audio-button.js.map
